import { cn } from '@cobliteam/colib-ui/cn';
import Typography from '@cobliteam/colib-ui/Typography';
import { PrismicRichText as BasePrismicRichText, type JSXMapSerializer, type PrismicRichTextProps } from '@prismicio/react';
import type { HTMLAttributes } from 'react';

const defaultComponents = (className: string): JSXMapSerializer => {
  return {
    heading1: ({ children }) => (
      <Typography variant='headline' className={cn('gap-1 break-words', 'text-foreground', className)}>
        {children}
      </Typography>
    ),
    heading2: ({ children }) => (
      <Typography variant='h4' className={cn('gap-1 break-words', 'text-foreground', className)} render={<p />}>
        {children}
      </Typography>
    ),
    heading3: ({ children }) => (
      <Typography variant='large' className={cn('gap-1 break-words', 'text-foreground', className)}>
        {children}
      </Typography>
    ),
    heading4: ({ children }) => (
      <Typography variant='title' className={cn('gap-1 break-words', 'text-foreground', className)}>
        {children}
      </Typography>
    ),
    paragraph: ({ children }) => (
      <Typography variant='body' className={cn('gap-1 break-words', 'text-foreground', className)}>
        {children}
      </Typography>
    ),
    strong: ({ children }) => (
      <Typography variant='body' className={cn('gap-1 break-words', 'font-semibold', 'text-foreground', cn(className))} render={<strong />}>
        {children}
      </Typography>
    ),
  };
};

type ExtendedPrismicRichTextProps = PrismicRichTextProps & HTMLAttributes<HTMLDivElement>;

export function PrismicRichText({ components, className, ...props }: ExtendedPrismicRichTextProps) {
  return <BasePrismicRichText components={{ ...defaultComponents(className ?? ''), ...components }} {...props} />;
}
